import { WidgetBase } from "./WidgetBase";
import { WidgetTypes } from "./WidgetTypes";
import { WidgetController } from "../WidgetController";
import { LanguageString } from "../../../Model/LanguageString";
import { WidgetUserIsNamedComponent } from "../Components/WidgetUserIsNamedComponent";
import { PopupUserIsNamedComponent } from "../Popups/PopupUserIsNamedComponent";


export class WidgetUserIsNamedProps {
    public title: LanguageString;
    public fixedLayout?: boolean;
    public settingsName?: string;

    constructor() {
        this.title = new LanguageString();
    }
}

export class WidgetUserIsNamed extends WidgetBase {
    props: WidgetUserIsNamedProps;

    constructor(controller: WidgetController) {
        super(controller, 2, 2);
        this.props = new WidgetUserIsNamedProps();
    }

    getType(): WidgetTypes {
        return WidgetTypes.UserIsNamed;
    }

    loadProps(jsonProps: string): void {
        if (jsonProps && jsonProps.length > 0) {
            this.props = JSON.parse(jsonProps);

            if (this.props.title == null)
                this.props.title = new LanguageString();
        } else
            this.props.title = new LanguageString();
    }

    saveProps(): string {
        console.log("save");
        console.log(this.props);
        return JSON.stringify(this.props);
    }

    createComponent(column: number, row: number, colSpan?: number, rowSpan?: number): HTMLElement {
        this.column = column;
        this.row = row;
        this.colSpan = colSpan ? colSpan : this.minColSpan;
        this.rowSpan = rowSpan ? rowSpan : this.minRowSpan;
        this.component = new WidgetUserIsNamedComponent({
            widget: this,
            title: this.props.title,
            settingsName: this.props.settingsName,
        });
        return this.component.render();
    }

    showPopup(): void {
        let popup = new PopupUserIsNamedComponent({ widget: this });
        document.body.appendChild(popup.render());
    }
}